import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function CreditErrorHandler() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleInsufficientCredits = useCallback(() => {
    setOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener('insufficient-credits', handleInsufficientCredits);
    return () => window.removeEventListener('insufficient-credits', handleInsufficientCredits);
  }, [handleInsufficientCredits]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={() => setOpen(false)} severity="warning" variant="filled">
        {t('credits.insufficientCredits')}
      </Alert>
    </Snackbar>
  );
}
